import { useTheme } from 'context/themeContext';
import { ReactComponent as Ic_close } from 'resources/icons/Ic_close.svg';
import SvgIcon from 'components/commons/icons/SvgIcon';

import './modalInfo.scss';

interface IModalInfo {
  title?: string;
  width?: string;
  height: string;
  children: any;
  style?: any;
  className?: any;
  closeAction?: () => void;
  onClick?: () => void;
}

export default function ModalInfo(props: IModalInfo) {
  const theme = useTheme();
  const { title, width, height, children, closeAction, style, className } = props;

  const onClose = ()=> {
    closeAction && closeAction();
  };

  return (
    <div className={`modal-info ${className}`} style={style}>
      <article className='modal-info-container' style={{ width: width, height: height }} >
        <div className='modal-info-header'>
          {closeAction && (
            <div className={'modal-info-header-close-icon'}>
              <div className='wrapper-close-icon' onClick={() => onClose()}>
                <SvgIcon Icon={Ic_close}/>
              </div>
            </div>
          )}
          {title && (
            <div className='modal-info-header-title'>
              <h3 style={{ marginTop: 0, marginBottom: 0, color: theme.colors.gray_700 }}>
                {title}
              </h3>
            </div>
          )}
        </div>
        <div className='modal-body'>{children}</div>
      </article>
    </div>
  );
}
